module.exports = __webpack_public_path__ + "static/img/hr2.4fcb7f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/hr2.jpg
// module id = 1ods
// module chunks = 0